import { render, staticRenderFns } from "./AscFaultMonitorItemHeader.vue?vue&type=template&id=f8f90bde&scoped=true&"
import script from "./AscFaultMonitorItemHeader.vue?vue&type=script&lang=js&"
export * from "./AscFaultMonitorItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./AscFaultMonitorItemHeader.vue?vue&type=style&index=0&id=f8f90bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f90bde",
  null
  
)

export default component.exports